import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorMessageComponent } from './error-message.component';
import { MatDialogModule } from '@angular/material';

@NgModule({
	declarations: [ErrorMessageComponent],
	entryComponents: [ErrorMessageComponent],
	imports: [CommonModule, MatDialogModule]
})
export class ErrorMessageModule {}
